module.exports = __webpack_public_path__ + "static/media/map-rectangle.ccf3ce10.png";